<template>
  <div class="home-index" v-show="!loading">
    <RouterView />
  </div>
</template>

<script>
import { onMounted, provide, ref } from 'vue'
import request from '@/utils/request'

export default {
  name: 'HomeIndex',
  setup () {
    const loading = ref(true)
    const articles = ref([])
    const totalpage = ref(0)
    const islastpage = ref(false)
    const currentPage = ref(1)
    const categories = ref([])
    const tags = ref([])

    const fetchData = async () => {
      try {
        const [articleRes, categoryRes] = await Promise.all([
          request('/article/all', 'get', { nextpage: currentPage.value }),
          request('/article/category', 'get', {})
        ])
        articles.value = articleRes.data.articles
        totalpage.value = articleRes.data.totalpage
        islastpage.value = articleRes.data.islastpage
        categories.value = categoryRes.categories
        tags.value = categoryRes.tags
        console.log('tags', tags.value)
      } catch (err) {
        console.error('数据加载失败', err)
      } finally {
        loading.value = false
      }
    }

    onMounted(() => {
      fetchData()
    })

    provide('articleData', { articles, totalpage, islastpage, currentPage, categories, tags })

    // // 全部数据在父节点请求，并使用provide和inject注入
    // const doneLoading = () => {
    //   loading.value = false
    // }
    // provide('doneLoading', doneLoading)
    return {
      loading
    }
  }
}
</script>

<style lang="less" scoped>
.home-index {
  // scrollbar-color: rgb(226, 226, 226) ;
  background-color: @backgroundColor;
  // background-color: rgb(245, 242, 240);
  overflow-x: hidden;
  overflow-y: auto;
  height: 100vh;
}

</style>>
